module.exports = "/_next/static/images/smith_ramen-866c927609c60ed27004ab3cd7a5bf00.jpg";